import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store/index";
import titleMixin from "./mixins/titleMixin";
import VeeValidate from "vee-validate";
import VeeValidatePortuguese from "vee-validate/dist/locale/pt_BR";
import VueScrollTo from "vue-scrollto";
import VueTooltip from "vue-directive-tooltip";
import VueTheMask from "vue-the-mask";
import FullCalendar from "vue-full-calendar";
import vSelectPage from "v-selectpage";
import vMoney from "v-money";
import VueClipboard from "vue-clipboard2";
import VuetifyToast from "vuetify-toast-snackbar";

import pt from "vuetify/src/locale/pt.ts";
import Vuetify from "vuetify";

import ActionCableVue from "actioncable-vue";

import "fullcalendar/dist/fullcalendar.min.css";
import "vue-directive-tooltip/css/index.css";
import vuetify from "./plugins/vuetify";
import "@babel/polyfill";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";

Vue.use(VueClipboard);

Vue.use(VuetifyToast, {
  x: "right",
  y: "top",
  timeout: 5000
});

Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: "error",
  connectionUrl: `${process.env.WEBSOCKET_URL}?token=${localStorage.authentication}`
});

Vue.use(vMoney, {
  decimal: ",",
  thousands: ".",
  prefix: "R$ ",
  precision: 2,
  masked: false
});

Vue.use(FullCalendar);
Vue.use(VueTheMask);
Vue.use(VueTooltip);

Vue.use(vSelectPage, {
  language: "en"
});

Vue.use(VueScrollTo);

Vue.use(VeeValidate, {
  locale: "pt_BR",
  dictionary: {
    pt_BR: VeeValidatePortuguese
  },
  inject: true
});

Vue.mixin(titleMixin);
Vue.router = router;

new Vue({
  el: "#app",
  router,
  store,

  components: {
    App
  },

  vuetify,
  template: "<App/>"
});

// Sentry.init({
//   dsn: "https://026d6244ebd64dc1a30321e1c583781c@sentry.io/1489154",
//   integrations: [
//     new Integrations.Vue({
//       Vue,
//       attachProps: true
//     })
//   ]
// });



// WEBPACK FOOTER //
// ./src/main.js